// The visitor's cookie choice. "granted" lets Google, TikTok and PostHog keep
// cookies and record visits; "denied" keeps them off. Until someone chooses,
// nothing that needs consent runs. index.html reads the same key on load and
// exposes window.hugoApplyConsent to switch the tags on or off.

export const CONSENT_KEY = "hugo_consent";

export function consentChoice() {
  try {
    const v = localStorage.getItem(CONSENT_KEY);
    return v === "granted" || v === "denied" ? v : null;
  } catch {
    return null;
  }
}

export function setConsent(choice) {
  const value = choice === "granted" ? "granted" : "denied";
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* storage unavailable: the choice lasts for this page only */
  }
  if (typeof window !== "undefined" && typeof window.hugoApplyConsent === "function") window.hugoApplyConsent(value);
  if (value === "denied") {
    try {
      localStorage.removeItem("hugo_first_touch");
      localStorage.removeItem("hugo_last_touch");
    } catch {
      /* storage unavailable */
    }
  }
  return value;
}
